import { render, staticRenderFns } from "./FactBanner.vue?vue&type=template&id=0c81f618&functional=true"
import script from "./FactBanner.vue?vue&type=script&lang=js"
export * from "./FactBanner.vue?vue&type=script&lang=js"
import style0 from "./FactBanner.vue?vue&type=style&index=0&id=0c81f618&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports